import React from 'react';
import {Modal} from '@mui/material';
import SVGIcons from '../../components/SVGIcon';
import {ModalWindowProps as Props} from './model.type';
import cn from './Model.style.module.scss';
export function ModalWindow(props: Props) {
  const [close, setClose] = React.useState(false);

  const onClose = (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    setClose(true);
    setTimeout(() => {
      if (props.onClose) props.onClose(e);
      setClose(false);
    }, 500);
  };

  const onClickModal = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <Modal
      open={props.isOpen}
      className={`${cn.customModal} ${close ? cn.modalClose : cn.modalOpen} ${
        props.wrapperClassName
      }`}
      onClose={onClose}>
      <div
        className={`${cn.content} ${
          close ? cn.contentClosed : cn.contentOpen
        } ${props.className}`}
        onClick={onClickModal}
        data-testid='modal-content'>
        {props.closeElement}
        {!props.hideHeader && props.title && (
          <div className={cn.headerContainer}>
            <p className={cn.headerContainer__title}>{props.title}</p>
          </div>
        )}
        {props.close &&
          (props.closeIcon ? (
            props.closeIcon
          ) : (
            <span
              className={cn.modalCloseIcon}
              onClick={onClose}
              data-testid='close-icon'>
              <SVGIcons type='cross-svg' />
            </span>
          ))}
        {props.children}
      </div>
    </Modal>
  );
}
